
export interface UsuarioInternoVm {
    publicId: string;
    nomeCompleto: string;
    apelido: string;
    cpf: string;
    celular: string;
    imagem: string;
    email: string;
    status: number;
    statusDescricao: string;
    permissoes: string[];


}


export interface UsuarioInternoStoreVm{
    publicId: string;
    nome: string;
    imagem: string;
    email: string;
    sessao: string;
    status: EStatusUsuario;
}

export enum EStatusUsuario {
    Cadastrado = 1,
    Confirmado = 2,
    Desativado = 3
}


export interface UsuarioSessoesVm {
    sessao: string;
    dispositivo: string;
    navegador: string;
    ip: string;
    ultimoIp:string;
    dataSessao: string;
    dataUltimaVerificacao: string;
}




export function dataAsUsuarioInternoVm (data: any) {
    return data as UsuarioInternoVm
}